import { render, staticRenderFns } from "./KeratoInput.vue?vue&type=template&id=8846b3fe&scoped=true&"
import script from "./KeratoInput.vue?vue&type=script&lang=js&"
export * from "./KeratoInput.vue?vue&type=script&lang=js&"
import style0 from "./KeratoInput.vue?vue&type=style&index=0&id=8846b3fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8846b3fe",
  null
  
)

export default component.exports